import { type FC, type PropsWithChildren, type ReactNode } from 'react';

import { useStyles } from './List.styles';

type ListProps = PropsWithChildren<{
	className?: string;
	dataCy?: string;
}>;

interface ListComponent extends FC<ListProps> {
	Item: FC<ListItemProps>;
}

export const List: ListComponent = ({ children, className, dataCy }) => {
	const { classes, cx } = useStyles();

	return (
		<ul data-cy={dataCy} className={cx(classes.list, className)}>
			{children}
		</ul>
	);
};

type ListItemProps = PropsWithChildren<{
	/**
	 * Icons expected to be 24x24px
	 */
	icon?: ReactNode;
	dataCy?: string;
}>;

const Item: FC<ListItemProps> = ({ icon, children, dataCy }) => {
	const { classes } = useStyles();

	return (
		<li data-cy={dataCy} className={classes.item}>
			{icon && (
				<>
					<div className={classes.fakeicon} />
					<div className={classes.icon}>{icon}</div>
				</>
			)}
			<div>{children}</div>
		</li>
	);
};

List.Item = Item;
